import { ApplicationRoutes } from "./constants/app-routes";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { store } from "./store/index";
import { ToastProvider } from "./components/Toast";
import { LoaderControl } from "./components/LoaderControl";

function App() {
  const persistor = persistStore(store);

  return (
    <Provider store={store}>
      <PersistGate
        loading={
          <div className="tw-w-full tw-min-h-screen tw-bg-act-blue-600 tw-flex tw-items-center tw-justify-center">
            <LoaderControl loading={true} overlay={false} minHeight="600px">
              <p>API Calls</p>
            </LoaderControl>
          </div>
        }
        persistor={persistor}
      >
        <ToastProvider>
          <ApplicationRoutes />
        </ToastProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
